import { Component, ReactNode } from 'react';

import { twclsx } from 'utils/twclsx';

interface CommentProps {
    type: string | null;
    children: ReactNode;
    className?: string;
}

interface CommentState {
    errorStyle: object;
}

export default class Comment extends Component<CommentProps, CommentState> {
    constructor(props: CommentProps) {
        super(props);
        this.state = {
            errorStyle: {
                sucsess: '#ddfedb',
                comment: '#dddddd',
                default: '#dddddd',
                error: '#ef4444',
                warning: '#fdfedb',
                info: '#dbeafe',
            },
        };
    }

    render() {
        const { children, className } = this.props;
        let style = this.state.errorStyle['comment'];
        if (this.props.type) {
            style = this.state.errorStyle[this.props.type];
        }

        return (
            <div style={{ color: style }} className={twclsx('block ', 'no-select', 'text-sm', 'mt-1', className)}>
                {children}
            </div>
        );
    }
}
